import React from 'react';
import PropTypes from 'prop-types';
import {convertValueToDollar} from 'common/utils';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Divider} from 'semantic-ui-react';

import _ from 'lodash';
import {connectWithCore} from 'framework/hocs';

// DEPRECATED
const ComparisonTable = (props) => {
  const {dynamicComponent, id, dataPath, dataType, config, title, data} = props;

  let columns = [...config.tableColumns].sort((a, b) => {
    return a.order - b.order;
  });

  let rows = [...config.tableRows].sort((a, b) => {
    return a.order - b.order;
  });

  let sortedRows;

  const getVal = (path) => _.get(dynamicComponent, path, _.get(data, path));

  if ((dynamicComponent || data) && dataType === 'nonMonetary') {
    sortedRows = rows.map((row, i) => {
      const originalVal = getVal(row.originalPath);
      const revisedVal = getVal(row.revisedPath);
      return [row.title, originalVal || '0', revisedVal || '0'];
    });
  } else if (dynamicComponent || data) {
    let originalTotal = 0;
    let revisedTotal = 0;
    sortedRows = rows.map((row, i) => {
      if (row.transform === 'total') {
        return [
          row.title,
          convertValueToDollar(parseFloat(originalTotal).toFixed(2)),
          convertValueToDollar(parseFloat(revisedTotal).toFixed(2)),
        ];
      } else {
        const originalVal = getVal(row.originalPath);
        const revisedVal = getVal(row.revisedPath);

        originalTotal = (parseFloat(originalTotal) + parseFloat(originalVal)).toFixed(2);
        revisedTotal = (parseFloat(revisedTotal) + parseFloat(revisedVal)).toFixed(2);

        return [
          row.title,
          convertValueToDollar(parseFloat(originalVal).toFixed(2)),
          convertValueToDollar(parseFloat(revisedVal).toFixed(2)),
        ];
      }
    });
  }

  return (
    <React.Fragment>
      {title ? <div>{title}</div> : null}
      <FemaGoTable type="static">
        <FemaGoTable.Header>
          <FemaGoTable.Row id={id || dataPath}>
            {!!columns &&
              columns.map((column, index) => {
                return (
                  <FemaGoTable.HeaderCell
                    key={column['Header'] + index}
                    className={'header-cell'}
                    id={column['Header']}
                    type="number"
                  >
                    {column['Header']}
                  </FemaGoTable.HeaderCell>
                );
              })}
          </FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>
          {sortedRows &&
            sortedRows.map((row, index) => {
              return (
                <FemaGoTable.Row>
                  {row.map((cell, index) => (
                    <FemaGoTable.NumberCell id={index}>{cell}</FemaGoTable.NumberCell>
                  ))}
                </FemaGoTable.Row>
              );
            })}
        </FemaGoTable.Body>
      </FemaGoTable>
      <Divider />
    </React.Fragment>
  );
};

export const ConnectedComparisonTable = connectWithCore(ComparisonTable);
export default ComparisonTable;
